import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

const addLeaveType = async (formData) => {
  try {
    const response = await api.post(
      UtilsUrl.rhURL() + `/leavetypes/addLeaveType`,
      formData
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
const getLeaveTypes = async (idUser) => {
  const response = await api.get(UtilsUrl.rhURL() + "/leavetypes/" + idUser);
  return response.data;
};
const updateLeaveType = async (leaveType) => {
  return await api.post(
    UtilsUrl.rhURL() + `/leavetypes/updateLeavetype`,
    leaveType
  );
};
const checkNomConge = async (NomConge, idUser) => {
  try {
    const response = await api.get(
      UtilsUrl.rhURL() + `/leavetypes/checkNomConge/${NomConge}/${idUser}`
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

const getLeaveType = async (idUser) => {
  return api
    .get(UtilsUrl.rhURL() + `/leavetypes/` + idUser)
    .then((response) => response.data)
    .catch((error) => {
      console.error(error);
      throw error;
    });
};
export {
  addLeaveType,
  getLeaveTypes,
  updateLeaveType,
  checkNomConge,
  getLeaveType,
};
